export default __webpack_public_path__ + "static/media/photo--lg--dinner.fe9abd1e.jpg";